goog.provide("shadow.js.shim.module$$mui$material$Divider");
goog.provide("module$shadow_js_shim_module$$mui$material$Divider");
shadow.js.shim.module$$mui$material$Divider = shadow.js.nativeProvides["@mui/material/Divider"] = shadow$bridge("@mui/material/Divider");
module$shadow_js_shim_module$$mui$material$Divider.default = shadow.js.shim.module$$mui$material$Divider;
